import { FC, ReactNode, useRef } from 'react';

const VideoDuration: FC<{
  onChange: (duration: number) => void;
  url: string;
  children: ReactNode;
}> = ({ url, children, onChange }) => {
  const ref = useRef<any>(null);
  return (
    <div>
      <video
        ref={ref}
        src={url}
        style={{ display: 'none' }}
        onLoadedMetadata={(e) => {
          const duration = (e.target as HTMLMediaElement).duration;
          if (isFinite(duration)) {
            onChange?.(Math.round(duration));
          } else {
            onChange?.(-1);
          }
        }}
      />
      {children}
    </div>
  );
};
export default VideoDuration;
